module.exports = __webpack_public_path__ + "static/media/ic_notif_success.037ed8cf.svg";